import { render } from "./PersonalObjectiveCard.vue?vue&type=template&id=fef06256&scoped=true"
import script from "./PersonalObjectiveCard.vue?vue&type=script&lang=js"
export * from "./PersonalObjectiveCard.vue?vue&type=script&lang=js"

import "./PersonalObjectiveCard.vue?vue&type=style&index=0&id=fef06256&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef06256"]])

export default __exports__